import { useEffect } from 'react'

// Module-level count so nested modals don't unlock the body until the last
// one unmounts.
let lockCount = 0

export function useBodyScrollLock() {
  useEffect(() => {
    lockCount += 1
    document.body.classList.add('scroll-locked')

    return () => {
      // Clamp so an out-of-sync unmount can't push the count negative and
      // leave the body permanently locked.
      lockCount = Math.max(0, lockCount - 1)

      if (lockCount === 0) {
        document.body.classList.remove('scroll-locked')
      }
    }
  }, [])
}
